import React from 'react';
import { Link } from 'react-router-dom';
import NewsCard from '../components/NewsCard';
import { useNews } from '../context/NewsContext';
import { motion } from 'framer-motion';
const News = () => {
  const { articles, feedStatus } = useNews();

  return (
    <div className="bg-[#050505] min-h-screen pt-32 pb-32">
      <main className="max-w-7xl mx-auto px-6">
        <header className="mb-16">
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="border-b border-white/5 pb-10"
          >
            <h1 className="text-5xl md:text-7xl font-black text-white tracking-tighter">
              The News <span className="text-[#CCFF00]">Stream</span>
            </h1>
            {feedStatus.loading && (
              <p className="mt-4 text-slate-500 text-sm">Loading…</p>
            )}
            {!feedStatus.loading && feedStatus.error && (
                <p className="mt-4 text-amber-500/90 text-xs font-medium max-w-2xl space-y-1">
                  <span className="block">
                    Live feed unavailable — showing demo data below.
                  </span>
                  <span className="block text-slate-400 font-normal">
                    {feedStatus.error}
                  </span>
                </p>
              )}
          </motion.div>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {articles.map((article) => (
            <NewsCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-20 flex justify-center">
          <Link
            to="/"
            className="px-12 py-5 border border-white/10 text-[10px] font-black uppercase tracking-[0.3em] text-white hover:bg-white hover:text-black transition-all"
          >
            Back to home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default News;